import { render } from "./UserGroupProjectPermission.vue?vue&type=template&id=7c376737"
import script from "./UserGroupProjectPermission.vue?vue&type=script&lang=ts"
export * from "./UserGroupProjectPermission.vue?vue&type=script&lang=ts"
script.render = render

export default script